import React, { useMemo } from "react";

import useQuoteData from "components/Quotes/useQuoteData";
import { GlobalOptionsContextProvider } from "components/GlobalOptions/GlobalOptionsContext";
import useWindowTitle from "helpers/context/Title/useWindowTitle";
import { useTranslations } from "@fenetech/translations";
import GlobalOptionsWizard from "components/GlobalOptions/GlobalOptionsWizard";
import { isNullOrWhiteSpace } from "helpers/objects";

const GlobalOptionsWizardMain: React.FC<any> = (props) => {

    const { quote, permissions } = useQuoteData();
    const tm = useTranslations();
    const title = useMemo(() => {
        const title: string[] = []
        if (quote && !isNullOrWhiteSpace(quote.orderNumber)) {
            title.push(quote.orderNumber);
        }
        title.push(tm.Get("Global Option Changes"));

        return title;
    }, [quote, tm]);

    useWindowTitle(...title);

    if (!quote || !permissions || !permissions.editQuote) {
        return null;
    }

    return <>
        <GlobalOptionsContextProvider quote={quote}>
            <GlobalOptionsWizard quote={quote} />
        </GlobalOptionsContextProvider>
    </>;
};

export default GlobalOptionsWizardMain;
